import { render, staticRenderFns } from "./MainLedgerCard2.vue?vue&type=template&id=ff8a0410&scoped=true"
import script from "./MainLedgerCard2.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard2.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerCard2.vue?vue&type=style&index=0&id=ff8a0410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8a0410",
  null
  
)

export default component.exports